import { Msg91Component } from './msg91/msg91.component';
import { AppPropertiesConfigListComponent } from './components/master-data-management/app-properties-config-controller/app-properties-config-list/app-properties-config-list.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashBoardComponent } from './components/dash-board/dash-board.component';
import { EmployeeAttendenceComponent } from './components/employee-module/employee-attendence/employee-attendence.component';
import { TaskTrackingComponent } from './components/employee-module/task-tracking/task-tracking.component';
import { UserTrackingComponent } from './components/employee-module/user-tracking/user-tracking.component';
import { BranchMasterManagementComponent } from './components/inventery-management/branch-master-management/branch-master-management.component';
import { DeleteBranchComponent } from './components/inventery-management/delete-branch/delete-branch.component';
import { DeleteIssueComponent } from './components/inventery-management/delete-issue/delete-issue.component';
import { DeleteProductComponent } from './components/inventery-management/delete-product/delete-product.component';
import { DeletePurchaseComponent } from './components/inventery-management/delete-purchase/delete-purchase.component';
import { DeleteTransferComponent } from './components/inventery-management/delete-transfer/delete-transfer.component';
import { DeleteVendorComponent } from './components/inventery-management/delete-vendor/delete-vendor.component';
import { MaterialIssueRequestsComponent } from './components/inventery-management/material-issue-requests/material-issue-requests.component';
import { MaterialIssuesComponent } from './components/inventery-management/material-issues/material-issues.component';
import { MaterialPurchaseComponent } from './components/inventery-management/material-purchase/material-purchase.component';
import { MaterialTransferComponent } from './components/inventery-management/material-transfer/material-transfer.component';
import { ProductOpeningBalanceComponent } from './components/inventery-management/product-opening-balance/product-opening-balance.component';
import { UpdateBranchComponent } from './components/inventery-management/update-branch/update-branch.component';
import { UpdateProductComponent } from './components/inventery-management/update-product/update-product.component';
import { UpdateVendorComponent } from './components/inventery-management/update-vendor/update-vendor.component';
import { VendorMasterManagementComponent } from './components/inventery-management/vendor-master-management/vendor-master-management.component';
import { CustomerAPKVersionComponent } from './components/master-data-management/customer-apk-version/customer-apk-version.component';
import { CustomerParamsComponent } from './components/master-data-management/customer-params/customer-params.component';
import { DeleteCustomerAPKComponent } from './components/master-data-management/delete-customer-apk/delete-customer-apk.component';
import { DeleteCustomerParamComponent } from './components/master-data-management/delete-customer-param/delete-customer-param.component';
import { DeleteParamComponent } from './components/master-data-management/delete-param/delete-param.component';
import { DeleteServiceDefinitionComponent } from './components/master-data-management/delete-service-definition/delete-service-definition.component';
import { DeleteTicketSubTypeComponent } from './components/master-data-management/delete-ticket-sub-type/delete-ticket-sub-type.component';
import { DeleteTicketTypeComponent } from './components/master-data-management/delete-ticket-type/delete-ticket-type.component';
import { ModifyCustomerAPKComponent } from './components/master-data-management/modify-customer-apk/modify-customer-apk.component';
import { ModifyCustomerParamComponent } from './components/master-data-management/modify-customer-param/modify-customer-param.component';
import { ModifyParamComponent } from './components/master-data-management/modify-param/modify-param.component';
import { ModifyServiceDefinitionComponent } from './components/master-data-management/modify-service-definition/modify-service-definition.component';
import { ModifyTicketSubTypeComponent } from './components/master-data-management/modify-ticket-sub-type/modify-ticket-sub-type.component';
import { ModifyTicketTypeComponent } from './components/master-data-management/modify-ticket-type/modify-ticket-type.component';
import { ParamsListComponent } from './components/master-data-management/params-list/params-list.component';
import { ParamsUpdateComponent } from './components/master-data-management/params-update/params-update.component';
import { RouteDeleteComponent } from './components/master-data-management/route-delete/route-delete.component';
import { RouteManagementComponent } from './components/master-data-management/route-management/route-management.component';
import { RouteModifyComponent } from './components/master-data-management/route-modify/route-modify.component';
import { ServiceDefinitionComponent } from './components/master-data-management/service-definition/service-definition.component';
import { TaskMasterComponent } from './components/master-data-management/task-master/task-master.component';
import { TicketSubTypeComponent } from './components/master-data-management/ticket-sub-type/ticket-sub-type.component';
import { TicketTypesComponent } from './components/master-data-management/ticket-types/ticket-types.component';
import { ModifyCompanyNewsComponent } from './components/modify-company-news/modify-company-news.component';
import { ModifyCustomerInfoComponent } from './components/modify-customer-info/modify-customer-info.component';
import { LocateDeviceComponent } from './components/network-visibility/locate-device/locate-device.component';
import { RouteMapComponent } from './components/network-visibility/route-map/route-map.component';
import { NotificationManagementComponent } from './components/notification-management/notification-management.component';
import { ObjectDeleteComponent } from './components/object-delete/object-delete.component';
import { ObjectModifyComponent } from './components/object-modify/object-modify.component';
import { ObjectTemplateComponent } from './components/object-template/object-template.component';
import { MarketingDataComponent } from './components/offer-module/marketing-data/marketing-data.component';
import { OfferAddComponent } from './components/offer-module/offer-add/offer-add.component';
import { OfferDeleteComponent } from './components/offer-module/offer-delete/offer-delete.component';
import { OfferListComponent } from './components/offer-module/offer-list/offer-list.component';
import { OfferModifyComponent } from './components/offer-module/offer-modify/offer-modify.component';
import { PendingApprovalComponent } from './components/pending-approval/pending-approval.component';
import { DeletePrivilegeComponent } from './components/privileges-controller/delete-privilege/delete-privilege.component';
import { ModifyPrivilegeComponent } from './components/privileges-controller/modify-privilege/modify-privilege.component';
import { PrivilegesListComponent } from './components/privileges-controller/privileges-list/privileges-list.component';
import { ProdcutCompositionComponent } from './components/prodcut-composition/prodcut-composition.component';
import { ProdcutDeleteComponent } from './components/prodcut-delete/prodcut-delete.component';
import { ProdcutModifyComponent } from './components/prodcut-modify/prodcut-modify.component';
import { ProductStockManagementComponent } from './components/product-stock-management/product-stock-management.component';
import { AddTaskComponent } from './components/task-management/add-task/add-task.component';
import { DeleteTaskComponent } from './components/task-management/delete-task/delete-task.component';
import { ModifyTaskComponent } from './components/task-management/modify-task/modify-task.component';
import { MyTasksComponent } from './components/task-management/my-tasks/my-tasks.component';
import { TaskCommComponent } from './components/task-management/task-comm/task-comm.component';
import { TaskFilterComponent } from './components/task-management/task-filter/task-filter.component';
import { TaskListComponent } from './components/task-management/task-list/task-list.component';
import { TaskPostedByMeComponent } from './components/task-management/task-posted-by-me/task-posted-by-me.component';
import { UserTaskComponent } from './components/task-management/user-task/user-task.component';
import { AddTicketComponent } from './components/ticket-management/add-ticket/add-ticket.component';
import { DeleteTicketComponent } from './components/ticket-management/delete-ticket/delete-ticket.component';
import { ModifyTicketComponent } from './components/ticket-management/modify-ticket/modify-ticket.component';
import { SearchTicketsComponent } from './components/ticket-management/search-tickets/search-tickets.component';
import { TicketCommComponent } from './components/ticket-management/ticket-comm/ticket-comm.component';
import { TicketFilterComponent } from './components/ticket-management/ticket-filter/ticket-filter.component';
import { TicketPostedByMeComponent } from './components/ticket-management/ticket-posted-by-me/ticket-posted-by-me.component';
import { TicketsListComponent } from './components/ticket-management/tickets-list/tickets-list.component';
import { UserTicketComponent } from './components/ticket-management/user-ticket/user-ticket.component';
import { ChangePasswordComponent } from './components/user-management/change-password/change-password.component';
import { CreateUserComponent } from './components/user-management/create-user/create-user.component';
import { DeleteRoleComponent } from './components/user-management/delete-role/delete-role.component';
import { DeleteUserComponent } from './components/user-management/delete-user/delete-user.component';
import { ModifyRoleComponent } from './components/user-management/modify-role/modify-role.component';
import { ModifyUserComponent } from './components/user-management/modify-user/modify-user.component';
import { RolesComponent } from './components/user-management/roles/roles.component';
import { UsersListComponent } from './components/user-management/users-list/users-list.component';
import { UserLiveTrackingComponent } from './components/user-management/user-live-tracking/user-live-tracking.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './home/home.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { StatusInfoComponent } from './components/master-data-management/status-info/status-info.component';
import { ObjectTypeGroupComponent } from './components/master-data-management/object-type-group/object-type-group.component';
import { MarketingDataFilterComponent } from './components/offer-module/marketing-data-filter/marketing-data-filter.component';
import { MarketingDataByUserComponent } from './components/offer-module/marketing-data-by-user/marketing-data-by-user.component';
import { ProfileComponent } from './components/user-management/profile/profile.component';
import { CompositionComponent } from './components/composition/composition.component';
import { ProductCompositionComponent } from './components/product-composition/product-composition.component';
import { CProductListComponent } from './components/c-product/c-product-list/c-product-list.component';
import { ProductCompositionListComponent } from './components/product-composition-list/product-composition-list.component';
import { AddMaterialChargeComponent } from './components/material-charge/add-material-charge/add-material-charge.component';
import { MaterialChargeListComponent } from './components/material-charge/material-charge-list/material-charge-list.component';
import { BatchInfoListComponent } from './components/batchInfo/batch-info-list/batch-info-list.component';
import { AddProductDisplayZoneComponent } from './components/product-display-zone-controller/add-product-display-zone/add-product-display-zone.component';
import { ProductDisplayZoneListComponent } from './components/product-display-zone-controller/product-display-zone-list/product-display-zone-list.component';
import { DeleteProductDisplayZoneComponent } from './components/product-display-zone-controller/delete-product-display-zone/delete-product-display-zone.component';
import { ModifyProductDisplayZoneComponent } from './components/product-display-zone-controller/modify-product-display-zone/modify-product-display-zone.component';
import { AddProductCategoryComponent } from './components/product-category-controller/add-product-category/add-product-category.component';
import { ProductCategoryListComponent } from './components/product-category-controller/product-category-list/product-category-list.component';
import { DeleteProductCategoryComponent } from './components/product-category-controller/delete-product-category/delete-product-category.component';
import { ModifyProductCategoryComponent } from './components/product-category-controller/modify-product-category/modify-product-category.component';
import { ProductCompositionDeleteComponent } from './components/product-composition-delete/product-composition-delete.component';
import { ProductCompositionModifyComponent } from './components/product-composition-modify/product-composition-modify.component';
import { AddProductMasterComponent } from './components/product-master-controller/add-product-master/add-product-master.component';
import { AllTaskStatusWiseComponent } from './components/task-management/all-task-status-wise/all-task-status-wise.component';
import { ProductMasterListComponent } from './components/product-master-controller/product-master-list/product-master-list.component';

import { AddProductMasterGroupComponent } from './components/master-data-management/product-master-group-controller/add-product-master-group/add-product-master-group.component';
import { ProductMasterGroupListComponent } from './components/master-data-management/product-master-group-controller/product-master-group-list/product-master-group-list.component';
import { ModifyProductMasterGroupComponent } from './components/master-data-management/product-master-group-controller/modify-product-master-group/modify-product-master-group.component';
import { DeleteProductMasterGroupComponent } from './components/master-data-management/product-master-group-controller/delete-product-master-group/delete-product-master-group.component';
import { LatestProductStockInfoComponent } from './components/inventery-management/latest-product-stock-info/latest-product-stock-info.component';

import { AddVendorComponent } from './components/inventery-management/vendor-master-controller/add-vendor/add-vendor.component';
import { VendorListComponent } from './components/inventery-management/vendor-master-controller/vendor-list/vendor-list.component';
import { VendorRequestsComponent } from './components/inventery-management/vendor-master-controller/vendor-requests/vendor-requests.component';
import { VendorApprovedComponent } from './components/inventery-management/vendor-master-controller/vendor-approved/vendor-approved.component';
import { VendorBlockedComponent } from './components/inventery-management/vendor-master-controller/vendor-blocked/vendor-blocked.component';
import { ExistingCustomerListComponent } from './components/existing-customer-module/existing-customer-list/existing-customer-list.component';
import { TobeApprovedListComponent } from './components/existing-customer-module/tobe-approved-list/tobe-approved-list.component';
import { EcMapComponent } from './components/existing-customer-module/ec-map/ec-map.component';
import { EcFilterComponent } from './components/existing-customer-module/ec-filter/ec-filter.component';
import { TobeVerifiedListComponent } from './components/existing-customer-module/tobe-verified-list/tobe-verified-list.component';
import { MaterialToBeIssuedComponent } from './components/inventery-management/material-to-be-issued/material-to-be-issued.component';
import { MaterialIssuedListComponent } from './components/inventery-management/material-issued-list/material-issued-list.component';
import { UpdateTicketPriorityTimeComponent } from './components/ticket-management/update-ticket-priority-time/update-ticket-priority-time.component';
import { UpdateTaskPriorityTimeComponent } from './components/task-management/update-task-priority-time/update-task-priority-time.component';
import { ClientDocComponent } from './components/client-doc/client-doc.component';
import { GeoFenceComponent } from './components/inventery-management/branch-master-management/geo-fence/geo-fence.component';
import { LayerObjectComponent } from './components/inventery-management/branch-master-management/layer-object/layer-object.component';
import { BranchMapComponent } from './components/inventery-management/branch-master-management/branch-map/branch-map.component';
import { UserLatestLocationComponent } from './components/employee-module/user-latest-location/user-latest-location.component';
import { AddCustomerProductPriceComponent } from './components/master-data-management/customer-product-price-controller/add-customer-product-price/add-customer-product-price.component';
import { CustomerProductPriceListComponent } from './components/master-data-management/customer-product-price-controller/customer-product-price-list/customer-product-price-list.component';
import { DeleteCustomerProductPriceComponent } from './components/master-data-management/customer-product-price-controller/delete-customer-product-price/delete-customer-product-price.component';
import { ModifyCustomerProductPriceComponent } from './components/master-data-management/customer-product-price-controller/modify-customer-product-price/modify-customer-product-price.component';
import { ReportComponent } from './components/user-management/report/report.component';
import { ObjectGroupListComponent } from './components/master-data-management/object-group-master-controller/object-group-list/object-group-list.component';
import { ObjectTypeListComponent } from './components/master-data-management/object-type-master-controller/object-type-list/object-type-list.component';
import { DeleteObjectTypeComponent } from './components/master-data-management/object-type-master-controller/delete-object-type/delete-object-type.component';
import { DeleteObjectGroupComponent } from './components/master-data-management/object-group-master-controller/delete-object-group/delete-object-group.component';
import { AccessPrivilegesRequestsComponent } from './components/client-doc/access-privileges-requests/access-privileges-requests.component';
import { PaymentTermListComponent } from './components/payment-term-controller/payment-term-list/payment-term-list.component';
import { AddPaymentTermComponent } from './components/payment-term-controller/add-payment-term/add-payment-term.component';
import { ModifyPaymentTermComponent } from './components/payment-term-controller/modify-payment-term/modify-payment-term.component';
import { DeletePaymentTermComponent } from './components/payment-term-controller/delete-payment-term/delete-payment-term.component';
import { AddLocationComponent } from './components/master-data-management/location-controller/add-location/add-location.component';
import { DeleteLocationComponent } from './components/master-data-management/location-controller/delete-location/delete-location.component';
import { LocationListComponent } from './components/master-data-management/location-controller/location-list/location-list.component';
import { ModifyLocationComponent } from './components/master-data-management/location-controller/modify-location/modify-location.component';
import { ClientDocsFilterComponent } from './components/client-doc/client-docs-filter/client-docs-filter.component';
import { AssetListComponent } from './components/master-data-management/asset-list/asset-list.component';
import { AssetListFilterComponent } from './components/master-data-management/asset-list-filter/asset-list-filter.component';
import { ObjectAllocationRegisterComponent } from './components/master-data-management/object-allocation-register/object-allocation-register.component';
import { MaintenanceScheduleComponent } from './components/master-data-management/maintenance-schedule/maintenance-schedule.component';
import { RepairInfoComponent } from './components/master-data-management/repair-info/repair-info.component';
import { HelpComponent } from './components/help/help.component';
import { PerformanceHistoryComponent } from './components/master-data-management/performance-history/performance-history.component';
import { UomComponent } from './components/uom/uom.component';
import { TicketPriorityDefinitionComponent } from './components/ticket-management/ticket-priority-definition/ticket-priority-definition.component';
import { TicketPriorityDefinitionControllerComponent } from './components/master-data-management/ticket-priority-definition-controller/ticket-priority-definition-controller.component';
import { TaskPriorityDefinitionComponent } from './components/task-management/task-priority-definition/task-priority-definition.component';
import { TicketTaskPriorityDefinitionComponent } from './components/ticket-task-priority-definition/ticket-task-priority-definition.component';
import { UserTypeComponent } from './components/user-type/user-type.component';
import { TaxMasterListComponent } from './components/tax-master-controller/tax-master-list/tax-master-list.component';
import { ObjectCategoryControllerComponent } from './components/object-category-controller/object-category-controller.component';
import { DepreciationRegisterControllerComponent } from './components/depreciation-register-controller/depreciation-register-controller.component';
import { ApprovalComponent } from './components/Prospect-Management/approval/approval.component';
import { ProspectInfoComponent } from './components/Prospect-Management/prospect-info/prospect-info.component';
import { AssetDeprciationMethodControllerComponent } from './components/asset-deprciation-method-controller/asset-deprciation-method-controller.component';
import { DepartmentInfoControllerComponent } from './components/master-data-management/department-info-controller/department-info-controller.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AssettoTicketComponent } from './components/ticket-management/assetto-ticket/assetto-ticket.component';
import { TicketBySourceComponent } from './components/ticket-management/ticket-by-source/ticket-by-source.component';
import { AssettoTaskComponent } from './components/task-management/assetto-task/assetto-task.component';
import { PageSoonComponent } from './page-soon/page-soon.component';
import { AssetLiveMonitoringComponent } from './components/master-data-management/asset-live-monitoring/asset-live-monitoring.component';
import { AssetDataRegisterComponent } from './components/master-data-management/asset-data-register/asset-data-register.component';
import { AssetBuldComponent } from './components/master-data-management/asset-buld/asset-buld.component';
import { AssetAuditInfoComponent } from './components/asset-audit-info/asset-audit-info.component';
import { AssetAuditReportComponent } from './components/asset-audit-report/asset-audit-report.component';
import { AssetPerformanceComponent } from './components/master-data-management/asset-performance/asset-performance.component';
import { AssetBudgetingComponent } from './components/asset-budgeting/asset-budgeting.component';
import { StatusInfoControllerComponent } from './components/master-data-management/status-info-controller/status-info-controller.component';
import { AssetReportComponent } from './components/master-data-management/asset-report/asset-report.component';
import { InventoryReportComponent } from './components/master-data-management/inventory-report/inventory-report.component';
import { EcComponent } from './components/existing-customer-module/ec/ec.component';
import { ObjectAllocationRegisterHistoryComponent } from './components/master-data-management/object-allocation-register-history/object-allocation-register-history.component';
import { IDealerListComponent } from './components/i-dealer-controller/i-dealer-list/i-dealer-list.component';
import { DealerLocateDeviceComponent } from './components/network-visibility/dealer-locate-device/dealer-locate-device.component';
import { DealerFilterComponent } from './components/i-dealer-controller/dealer-filter/dealer-filter.component';
import { RouteAccessGuard } from './guards/route-access.guard';
import { TelcoCustomerControllerComponent } from './components/telco-customer-controller/telco-customer-controller.component';
import { PrintComponent } from './print/print.component';
import { TelcoMapComponent } from './components/telco-map/telco-map.component';
import { DashBoard1Component } from './components/dash-board1/dash-board1.component';
import { AssetComponent } from './components/master-data-management/asset/asset.component';
import { AssetHoldingComponent } from './components/master-data-management/asset-holding/asset-holding.component';
import { TemplateCountsComponent } from './components/master-data-management/template-counts/template-counts.component';
import { LiveComponent } from './live/live.component';
import { ObjectAllocationRegisterGroupComponent } from './components/master-data-management/object-allocation-register-group/object-allocation-register-group.component';
import { AssetCompareComponent } from './components/master-data-management/asset-compare/asset-compare.component';
import { CustomerInfoComponent } from './components/customer-info/customer-info.component';
import { CustomerLocationInfoComponent } from './components/customer-location-info/customer-location-info.component';
import { VerificationComponent } from './components/Prospect-Management/verification/verification.component';
import { FacesRegisterComponent } from './components/master-data-management/faces-register/faces-register.component';
import { ServiceProvidersControllerComponent } from './components/service-providers-controller/service-providers-controller.component';
import { ObjectTransitControllerComponent } from './components/object-transit-controller/object-transit-controller.component';
import { RolesControllerComponent } from './components/user-management/roles-controller/roles-controller.component';
import { UploadBulkAssetMapComponent } from './components/master-data-management/upload-bulk-asset-map/upload-bulk-asset-map.component';
import { DefineServiceComponent } from './components/service-definition-controller/define-service/define-service.component';
import { PrivilegesGenerateComponent } from './components/user-management/privileges-generate/privileges-generate.component';
import { RolesGenerateComponent } from './components/user-management/roles-generate/roles-generate.component';
import { BusinessOwnerComponent } from './components/user-management/business-owner/business-owner.component';
import { ClientConfigListComponent } from './components/client-config/client-config-list/client-config-list.component';
import { CompanyInfoControllerComponent } from './components/company-info-controller/company-info-controller.component';

// TV Production Tracker Components
import { EpisodeWorkflowComponent } from './components/TvProductionTracker/Episode/episode-workflow/episode-workflow.component';
import { PcrWorkflowComponent } from './components/TvProductionTracker/Pcr/pcr-workflow/pcr-workflow.component';
import { CameramanWorkflowComponent } from './components/TvProductionTracker/Cameraman/cameraman-workflow/cameraman-workflow.component';
import { EditorWorkflowComponent } from './components/TvProductionTracker/Editor/editor-workflow/editor-workflow.component';
import { TitleWorkflowComponent } from './components/TvProductionTracker/Title/title-workflow/title-workflow.component';
import { GraphicsWorkflowComponent } from './components/TvProductionTracker/Graphics/graphics-workflow/graphics-workflow.component';
import { SeoWorkflowComponent } from './components/TvProductionTracker/SEO/seo-workflow/seo-workflow.component';
import { QualityCheckWorkflowComponent } from './components/TvProductionTracker/QualityCheck/quality-check-workflow/quality-check-workflow.component';
import { PublishingWorkflowComponent } from './components/TvProductionTracker/Publishing/publishing-workflow/publishing-workflow.component';
import { TvProductionTrackerFilterComponent } from './components/TvProductionTracker/tv-production-tracker-filter/tv-production-tracker-filter.component';
import { TvProductionTrackerCalendarComponent } from './components/TvProductionTracker/tv-production-tracker-calendar/tv-production-tracker-calendar.component';
import { AssetStockPointComponent } from './components/master-data-management/asset-stock-point/asset-stock-point.component';
import { AssettoGptComponent } from './components/assetto-gpt/assetto-gpt.component';

const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'admin',
    component: HomeComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [RouteAccessGuard],
    children: [
      {
        path: '',
        component: DashBoardComponent,
      },
      {
        path: 'dashBoard1',
        component: DashBoard1Component,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'template-manager',
        component: Msg91Component,
      },
      {
        path: 'help',
        component: HelpComponent,

      },
      {
        path: 'ticketlist',
        component: AssettoTicketComponent,
      },
      {
        path: 'ticket-by-source',
        component: TicketBySourceComponent,
      },
      {
        path: 'ticket-list',
        component: TicketsListComponent,
      },
      {
        path: 'ticket-prioritytime-list',
        component: UpdateTicketPriorityTimeComponent,
      },
      {
        path: 'search-ticket',
        component: SearchTicketsComponent,
      },
      {
        path: 'ticket-filter',
        component: TicketFilterComponent,
      },
      {
        path: 'user-ticket-filter',
        component: UserTicketComponent,
      },
      {
        path: 'addticket',
        component: AddTicketComponent,
      },
      {
        path: 'params',
        component: ParamsListComponent,
      },
      {
        path: 'delete-param',
        component: DeleteParamComponent,
      },
      {
        path: 'params-update',
        component: ParamsUpdateComponent,
      },
      {
        path: 'modify-params',
        component: ModifyParamComponent,
      },
      {
        path: 'ticketcomm',
        component: TicketCommComponent,
      },
      {
        path: 'modifyticket',
        component: ModifyTicketComponent,
      },
      {
        path: 'deleteticket',
        component: DeleteTicketComponent,
      },
      {
        path: 'tasklist',
        component: AssettoTaskComponent,
      },
      {
        path: 'task-list',
        component: TaskListComponent,
      },
      {
        path: 'update-taskpriority-time',
        component: UpdateTaskPriorityTimeComponent,
      },
      {
        path: 'addtask',
        component: AddTaskComponent,
      },
      {
        path: 'all-task-status-wise',
        component: AllTaskStatusWiseComponent,
      },
      {
        path: 'task-filter',
        component: TaskFilterComponent,
      },
      {
        path: 'user-task-filter',
        component: UserTaskComponent,
      },
      {
        path: 'taskcomm',
        component: TaskCommComponent,
      },
      {
        path: 'modifytask',
        component: ModifyTaskComponent,
      },
      {
        path: 'deletetask',
        component: DeleteTaskComponent,
      },
      {
        path: 'taskPostedByMe',
        component: TaskPostedByMeComponent,
      },
      {
        path: 'users-list',
        component: UsersListComponent,
      },
      {
        path: 'delete-user',
        component: DeleteUserComponent,
      },
      {
        path: 'modify-user',
        component: ModifyUserComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
      {
        path: 'create-user',
        component: CreateUserComponent,
      },
      {
        path: 'business-owner',
        component: BusinessOwnerComponent,
      },

      {
        path: 'dash-board',
        component: DashBoardComponent,
      },
      {
        path: 'plan-definition',
        component: ServiceDefinitionComponent,
      },
      {
        path: 'delete-plan-definition',
        component: DeleteServiceDefinitionComponent,
      },
      {
        path: 'modify-plan-definition',
        component: ModifyServiceDefinitionComponent,
      },
      {
        path: 'ticket-types',
        component: TicketTypesComponent,
      },
      {
        path: 'delete-ticket-type',
        component: DeleteTicketTypeComponent,
      },
      {
        path: 'modify-ticket-types',
        component: ModifyTicketTypeComponent,
      },
      {
        path: 'ticket-sub-types',
        component: TicketSubTypeComponent,
      },
      {
        path: 'delete-ticket-sub-type',
        component: DeleteTicketSubTypeComponent,
      },
      {
        path: 'modify-ticket-sub-types',
        component: ModifyTicketSubTypeComponent,
      },
      {
        path: 'ticketPostedByMe',
        component: TicketPostedByMeComponent,
      },

      {
        path: 'product',
        component: ProductMasterListComponent,
      },
      {
        path: 'add-product-master',
        component: AddProductMasterComponent,
      },
      {
        path: 'delete-product',
        component: DeleteProductComponent,
      },
      {
        path: 'update-product',
        component: UpdateProductComponent,
      },
      {
        path: 'add-vendor',
        component: AddVendorComponent,
      },
      {
        path: 'vendor-list',
        component: VendorListComponent,
      },
      {
        path: 'vendor-request',
        component: VendorRequestsComponent,
      },
      {
        path: 'vendor',
        component: VendorMasterManagementComponent,
      },
      {
        path: 'delete-vendor',
        component: DeleteVendorComponent,
      },
      {
        path: 'update-vendor',
        component: UpdateVendorComponent,
      },
      {
        path: 'network-design',
        component: GeoFenceComponent,
      },
      {
        path: 'layer-object',
        component: LayerObjectComponent,
      },
      {
        path: 'branch-map',
        component: BranchMapComponent,
      },
      {
        path: 'branch',
        component: BranchMasterManagementComponent,
      },
      {
        path: 'delete-branch',
        component: DeleteBranchComponent,
      },
      {
        path: 'update-branch',
        component: UpdateBranchComponent,
      },
      {
        path: 'material-purchases',
        component: MaterialPurchaseComponent,
      },
      {
        path: 'delete-purchase',
        component: DeletePurchaseComponent,
      },
      {
        path: 'material-issues',
        component: MaterialIssuesComponent,
      },
      {
        path: 'delete-issues',
        component: DeleteIssueComponent,
      },
      {
        path: 'delete-transfer',
        component: DeleteTransferComponent,
      },
      {
        path: 'material-transfer',
        component: MaterialTransferComponent,
      },
      {
        path: 'material-requests',
        component: MaterialIssueRequestsComponent,
      },
      {
        path: 'productstock',
        component: ProductStockManagementComponent,
      },
      {
        path: 'latest-product-stock',
        component: LatestProductStockInfoComponent,
      },
      {
        path: 'notification',
        component: NotificationManagementComponent,
      },
      {
        path: 'object-template',
        component: ObjectTemplateComponent,
      },
      {
        path: 'performance-history',
        component: PerformanceHistoryComponent,
      },
      {
        path: 'object-category',
        component: ObjectCategoryControllerComponent,
      },
      {
        path: 'asset-deprciation',
        component: AssetDeprciationMethodControllerComponent,
      },
      {
        path: 'asset-status',
        component: StatusInfoControllerComponent,
      },

      {
        path: 'asset-report',
        component: AssetReportComponent,
      },

      {
        path: 'inventory-report',
        component: InventoryReportComponent,
      },
      {
        path: 'depreciation-register',
        component: DepreciationRegisterControllerComponent,
      },
      {
        path: 'department',
        component: DepartmentInfoControllerComponent,
      },
      {
        path: 'object-allocation-register',
        component: ObjectAllocationRegisterComponent,
      },
      {
        path: 'object-allocation-register-group',
        component: ObjectAllocationRegisterGroupComponent,
      },
      {
        path: 'object-allocation-register-history',
        component: ObjectAllocationRegisterHistoryComponent,
      },
      {
        path: 'maintenance-schedule-list',
        component: MaintenanceScheduleComponent,
      },
      {
        path: 'repair-info-list',
        component: RepairInfoComponent,
      },
      {
        path: 'asset-audit-info',
        component: AssetAuditInfoComponent,
      },
      {
        path: 'asset-audit-report',
        component: AssetAuditReportComponent,
      },
      {
        path: 'asset-list',
        component: AssetListComponent,
      },
      {
        path: 'asset-holding',
        component: AssetHoldingComponent,
      },
      {
        path: 'asset',
        component: AssetComponent,
      },
      {
        path: 'asset-bulk',
        component: AssetBuldComponent,
      },
      {
        path: 'asset-list-filter',
        component: AssetListFilterComponent,
      },
      {
        path: 'asset-stock-point',
        component: AssetStockPointComponent,
      },
      {
        path: 'delete-object',
        component: ObjectDeleteComponent,
      },
      {
        path: 'modify-object',
        component: ObjectModifyComponent,
      },
      {
        path: 'product-opening-balance',
        component: ProductOpeningBalanceComponent,
      },
      {
        path: 'roles',
        component: RolesComponent,
      },
      {
        path: 'delete-role',
        component: DeleteRoleComponent,
      },
      {
        path: 'modify-roles',
        component: ModifyRoleComponent,
      },
      {
        path: 'app-properties-config',
        component: AppPropertiesConfigListComponent,
      },
      {
        path: 'task-master',
        component: TaskMasterComponent,
      },

      {
        path: 'customer-params',
        component: CustomerParamsComponent,
      },
      {
        path: 'delete-customer-param',
        component: DeleteCustomerParamComponent,
      },
      {
        path: 'modify-customer-params',
        component: ModifyCustomerParamComponent,
      },
      {
        path: 'uom',
        component: UomComponent,
      },
      {
        path: 'ticket-priority-definition',
        component: TicketPriorityDefinitionComponent,
      },
      {
        path: 'ticket-priority-definition-controller',
        component: TicketPriorityDefinitionControllerComponent,
      },
      {
        path: 'task-priority-definition',
        component: TaskPriorityDefinitionComponent,
      },
      {
        path: 'ticket-task-priority-definition',
        component: TicketTaskPriorityDefinitionComponent,
      },
      {
        path: 'user-type',
        component: UserTypeComponent,
      },
      {
        path: 'tax-master-list',
        component: TaxMasterListComponent,
      },
      {
        path: 'customer-approval',
        component: PendingApprovalComponent,
      },
      {
        path: 'modify-customer-info',
        component: ModifyCustomerInfoComponent,
      },
      {
        path: 'modify-company-news',
        component: ModifyCompanyNewsComponent,
      },
      {
        path: 'privileges-list',
        component: PrivilegesListComponent,
      },
      {
        path: 'delete-privileges',
        component: DeletePrivilegeComponent,
      },
      {
        path: 'modify-privileges',
        component: ModifyPrivilegeComponent,
      },
      {
        path: 'my-tasks',
        component: MyTasksComponent,
      },
      {
        path: 'user-tracking',
        component: UserTrackingComponent,
      },
      {
        path: 'user-latest-tracking',
        component: UserLatestLocationComponent,
      },
      {
        path: 'user-live-tracking',
        component: UserLiveTrackingComponent,
      },
      {
        path: 'prodcut-composition',
        component: ProdcutCompositionComponent,
      },
      {
        path: 'delete-prodcut',
        component: ProdcutDeleteComponent,
      },
      {
        path: 'modify-prodcut',
        component: ProdcutModifyComponent,
      },
      {
        path: 'route-list',
        component: RouteManagementComponent,
      },
      {
        path: 'delete-route',
        component: RouteDeleteComponent,
      },
      {
        path: 'modify-route',
        component: RouteModifyComponent,
      },
      {
        path: 'route-map',
        component: RouteMapComponent,
      },
      {
        path: 'locate-device',
        component: LocateDeviceComponent,
      },
      {
        path: 'dealer-locate-device',
        component: DealerLocateDeviceComponent,
      },
      {
        path: 'offer-list',
        component: OfferListComponent,
      },
      {
        path: 'offer-add',
        component: OfferAddComponent,
      },
      {
        path: 'offer-delete',
        component: OfferDeleteComponent,
      },
      {
        path: 'offer-modify',
        component: OfferModifyComponent,
      },
      {
        path: 'marketing-data',
        component: MarketingDataComponent,
      },
      {
        path: 'marketing-data-filter',
        component: MarketingDataFilterComponent,
      },
      {
        path: 'marketing-data-filter-by-user',
        component: MarketingDataByUserComponent,
      },
      {
        path: 'employee-attendence',
        component: EmployeeAttendenceComponent,
      },
      {
        path: 'task-tracking',
        component: TaskTrackingComponent,
      },
      {
        path: 'customer-APK',
        component: CustomerAPKVersionComponent,
      },
      {
        path: 'delete-customer-APK',
        component: DeleteCustomerAPKComponent,
      },
      {
        path: 'modify-customer-APK',
        component: ModifyCustomerAPKComponent,
      },
      {
        path: 'status-info',
        component: StatusInfoComponent,
      },
      {
        path: 'object-type-group',
        component: ObjectTypeGroupComponent,
      },
      {
        path: 'object-group',
        component: ObjectGroupListComponent,
      },
      {
        path: 'delete-object-group',
        component: DeleteObjectGroupComponent,
      },
      {
        path: 'object-type',
        component: ObjectTypeListComponent,
      },
      {
        path: 'delete-object-type',
        component: DeleteObjectTypeComponent,
      },
      {
        path: 'c-product-list',
        component: CProductListComponent,
      },
      {
        path: 'composition',
        component: CompositionComponent,
      },
      {
        path: 'product-composition',
        component: ProductCompositionListComponent,
      },
      {
        path: 'delete-product-composition',
        component: ProductCompositionDeleteComponent,
      },
      {
        path: 'modify-product-composition',
        component: ProductCompositionModifyComponent,
      },
      {
        path: 'product-composition-list',
        component: ProductCompositionListComponent,
      },
      {
        path: 'add-material-charge',
        component: AddMaterialChargeComponent,
      },
      {
        path: 'material-to-be-issued',
        component: MaterialToBeIssuedComponent,
      },
      {
        path: 'material-issued-list',
        component: MaterialIssuedListComponent,
      },
      {
        path: 'material-charge-list',
        component: MaterialChargeListComponent,
      },
      {
        path: 'batch-info-list',
        component: BatchInfoListComponent,
      },

      {
        path: 'add-product-display-zone',
        component: AddProductDisplayZoneComponent,
      },
      {
        path: 'product-display-zone-list',
        component: ProductDisplayZoneListComponent,
      },
      {
        path: 'delete-product-display-zone',
        component: DeleteProductDisplayZoneComponent,
      },
      {
        path: 'edit-product-display-zone',
        component: ModifyProductDisplayZoneComponent,
      },
      {
        path: 'add-location',
        component: AddLocationComponent,
      },
      {
        path: 'delete-location',
        component: DeleteLocationComponent,
      },
      {
        path: 'list-location',
        component: LocationListComponent,
      },
      {
        path: 'modify-location',
        component: ModifyLocationComponent,
      },
      {
        path: 'add-product-category',
        component: AddProductCategoryComponent,
      },
      {
        path: 'product-category-list',
        component: ProductCategoryListComponent,
      },
      {
        path: 'delete-product-category',
        component: DeleteProductCategoryComponent,
      },
      {
        path: 'modify-product-category',
        component: ModifyProductCategoryComponent,
      },
      {
        path: 'add-product-master-group',
        component: AddProductMasterGroupComponent,
      },
      {
        path: 'product-master-group-list',
        component: ProductMasterGroupListComponent,
      },
      {
        path: 'modify-product-master-group',
        component: ModifyProductMasterGroupComponent,
      },
      {
        path: 'delete-product-master-group',
        component: DeleteProductMasterGroupComponent,
      },
      {
        path: 'vendor-approve-list',
        component: VendorApprovedComponent,
      },
      {
        path: 'vendor-block-list',
        component: VendorBlockedComponent,
      },
      {
        path: 'ec-list',
        component: ExistingCustomerListComponent,
      },
      {
        path: 'ec-requests-list',
        component: TobeApprovedListComponent,
      },
      {
        path: 'ec-to-be-approved-list',
        component: TobeVerifiedListComponent,
      },
      {
        path: 'ec-filter-list',
        component: EcFilterComponent,
      },
      {
        path: 'ec-map',
        component: EcMapComponent,
      },
      {
        path: 'ec-form',
        component: EcComponent,
      },
      {
        path: 'client-doc',
        component: ClientDocComponent,
      },
      {
        path: 'client-doc-filter',
        component: ClientDocsFilterComponent,
      },
      {
        path: 'access-privileges-requests',
        component: AccessPrivilegesRequestsComponent,
      },
      {
        path: 'add-customer-product-price',
        component: AddCustomerProductPriceComponent,
      },
      {
        path: 'customer-product-price-list',
        component: CustomerProductPriceListComponent,
      },
      {
        path: 'delete-customer-product-price',
        component: DeleteCustomerProductPriceComponent,
      },
      {
        path: 'modify-customer-product-price',
        component: ModifyCustomerProductPriceComponent,
      },
      {
        path: 'employee-hierarchy',
        component: ReportComponent,
      },
      {
        path: 'add-payment-term',
        component: AddPaymentTermComponent,
      },
      {
        path: 'payment-term-list',
        component: PaymentTermListComponent,
      },
      {
        path: 'modify-payment-term',
        component: ModifyPaymentTermComponent,
      },
      {
        path: 'delete-payment-term',
        component: DeletePaymentTermComponent,
      },
      {
        path: 'approval',
        component: ApprovalComponent,
      },
      {
        path: 'prospect',
        component: ProspectInfoComponent,
      },
      {
        path: 'verification',
        component: VerificationComponent,
      },
      { path: 'asset-live-monitoring', component: AssetLiveMonitoringComponent },
      { path: 'asset-data-register', component: AssetDataRegisterComponent },
      { path: 'asset-performance', component: AssetPerformanceComponent },
      { path: 'asset-budgeting', component: AssetBudgetingComponent },
      { path: 'i-dealer-list', component: IDealerListComponent },
      { path: 'i-dealer-update', component: DealerFilterComponent },
      { path: 'telco-customer', component: TelcoCustomerControllerComponent },
      { path: 'telco-map', component: TelcoMapComponent },
      { path: 'template-counts', component: TemplateCountsComponent },
      { path: 'live-camera', component: LiveComponent },
      { path: 'asset-compare', component: AssetCompareComponent },
      {
        path: 'customer-info',
        component: CustomerInfoComponent,
      },
      {
        path: 'customer-location-info',
        component: CustomerLocationInfoComponent,
      },
      {
        path: 'faces-register',
        component: FacesRegisterComponent,
      },
      {
        path: 'service-providers',
        component: ServiceProvidersControllerComponent,
      },
      {
        path: 'object-transit',
        component: ObjectTransitControllerComponent,
      },
      {
        path: 'bulk-object-transit',
        component: ObjectTransitControllerComponent,
      },
      {
        path: 'user-roles',
        component: RolesControllerComponent,
      },
      {
        path: 'upload-bulk-asset-map',
        component: UploadBulkAssetMapComponent,
      },
      {
        path: 'services',
        component: DefineServiceComponent,
      },
      {
        path: 'privileges-generate',
        component: PrivilegesGenerateComponent,
      },
      {
        path: 'roles-generate',
        component: RolesGenerateComponent,
      },
      {
        path: 'role-list',
        component: RolesControllerComponent,
      },
      {
        path: 'client-list',
        component: ClientConfigListComponent,
      },
      {
        path: 'company-info',
        component: CompanyInfoControllerComponent,
      },
      {
        path: 'episodes',
        component: EpisodeWorkflowComponent,
      },
      {
        path: 'pcr',
        component: PcrWorkflowComponent,
      },
      {
        path: 'cameraman',
        component: CameramanWorkflowComponent,
      },
      {
        path: 'editor',
        component: EditorWorkflowComponent,
      },
      {
        path: 'title',
        component: TitleWorkflowComponent,
      },
      {
        path: 'graphics',
        component: GraphicsWorkflowComponent,
      },
      {
        path: 'seo',
        component: SeoWorkflowComponent,
      },
      {
        path: 'quality-check',
        component: QualityCheckWorkflowComponent,
      },
      {
        path: 'publishing',
        component: PublishingWorkflowComponent,
      },
      {
        path: 'tv-production-tracker-filter',
        component: TvProductionTrackerFilterComponent,
      },
      {
        path: 'ticket-priority-definition-controller',
        component: TicketPriorityDefinitionControllerComponent,
      },
      {
        path: 'tv-production-tracker-calendar',
        component: TvProductionTrackerCalendarComponent,
      }
    ]
  },
  {
    path: 'assetto-ai',
    component: AssettoGptComponent
  },
  {
    path: 'restaurant',
    loadChildren: () => import('./restaurant/restaurant.module').then(m => m.RestaurantModule)
  },
  {
    path: 'kiosk',
    loadChildren: () => import('./kiosk/kiosk.module').then(m => m.KioskModule)
  },
  {
    path: 'kiosk-frontend',
    redirectTo: 'kiosk',
    pathMatch: 'prefix'
  },
  {
    path: 'kitchen',
    loadChildren: () => import('./kitchen/kitchen.module').then(m => m.KitchenModule)
  },
  {
    path: 'kiosk-kitchen',
    redirectTo: 'kitchen',
    pathMatch: 'prefix'
  },
  {
    path: 'customer-display',
    loadChildren: () => import('./customer-display/customer-display.module').then(m => m.CustomerDisplayModule)
  },
  {
    path: 'kiosk-customer-display',
    redirectTo: 'customer-display',
    pathMatch: 'prefix'
  },
  // {
  //   path: '',
  //   component: PageNotFoundComponent,
  // },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
